mutation UploadFile($input: UploadFileInput!) {
  file: uploadFile(input: $input) {
    id
    url
  }
}
